import React from "react";
import { formatLongDate } from "utilities";
import { findEnumLabel } from "utilities/enumutils";
import { NextIsCancelled, NextIsFree, NextIsReadOnly, NotImplementedSubscription } from "../../../Subscription/Components/CommonPanelContent";
import SaveByPayingPerYear from "../../../Subscription/Components/SaveByPayingPerYear";
import UpToInternalUsers from "../../../Subscription/Components/UpToInternalUsers";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const NextIsAgainPaid = (props: Props) => {
  const billingCycleWillChange = () => (props.activeSubscription.billingCycle !== props.nextBillingCycle.value);

  return (<>

    <div className="card-floating-bg radius padding-large">
      <table className="s1_table rowspace">
        <tbody>
          <tr>
            <td>{RESX.Subscription.BillingCycle}:</td>
            <td>
              <div>{findEnumLabel(props.activeSubscription.billingCycle, serverReference.billingCycles)}</div>
              {billingCycleWillChange() && <div className="text-sublabel">{RESX.Subscription.ChangesToXOn.replace("{0}", props.nextBillingCycle.text)} {formatLongDate(props.activeSubscription.end)}</div>}
            </td>
          </tr><tr>
            <td>{RESX.SoUser.Users}:</td>
            <td><UpToInternalUsers upTo={props.activeSubscription.internalUsers} /></td>
          </tr><tr>
            <td>{RESX.Subscription.Renewal}:</td>
            <td>{formatLongDate(props.activeSubscription.end)}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <SaveByPayingPerYear {...props} />

  </>);
};

const PaidSubscription = (props: Props) => {
  switch (props.nextSubscriptionType.value) {
    case "free":
      return <NextIsFree {...props} />;
    case "paid":
      return <NextIsAgainPaid {...props} />;
    case "readOnly":
      return <NextIsReadOnly {...props} />;
    case "cancelledByClient":
    case "cancelledBySystemOne":
    case "trialEnd":
      return <NextIsCancelled {...props} tip="readOnly" />;
    default:
      return <NotImplementedSubscription />;
  }
};

export default PaidSubscription;
